export default __webpack_public_path__ + "static/media/013_photo.e350c685.jpg";